import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-company-tools',
  templateUrl: './company-tools.component.html',
  styleUrls: ['./company-tools.component.scss']
})
export class CompanyToolsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
